import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { conclusioniCkHelper, getConclusioniControl } from './helpers/conclusioni-form.helper';
import { addRemoveError, getControl, getGroup } from '@shared/helpers/form.helper';
import { isNilOrEmpty, toBoolean } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isEqual } from 'lodash-es';
import { formPaths } from '@shared/constants/form-paths.const';

export const conclusioniPropostaLiquidazioneCoattaRules: FormGroupRules = {
    my_descMotivoProposta: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaLiqCoatta.my_descMotivoProposta', 'my_CkProvvedimendoDi', 5);
    },

    my_DescVertenzeGiudiz: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_DescVertenzeGiudiz', 'my_CkVertenzeGiudiz', 1, 'my_SezioneI__Rilevazione.my_AltreNotizie');
    },

    my_descAzAvviate: (form: FormGroup) => {
        const my_descAzAvviateControl = getConclusioniControl(form, 'my_SchedaPropostaLiqCoatta.my_descAzAvviate');
        const my_ckAvvIstanzaFall: string | boolean = getConclusioniControl(form, 'my_SchedaPropostaLiqCoatta.my_ckAvvIstanzaFall').value;
        const my_ckAvvDecrIngiunt: string | boolean = getConclusioniControl(form, 'my_SchedaPropostaLiqCoatta.my_ckAvvDecrIngiunt').value;
        const my_ckAvvAzEsec: string | boolean = getConclusioniControl(form, 'my_SchedaPropostaLiqCoatta.my_ckAvvAzEsec').value;
        const my_ckAvvProtesti: string | boolean = getConclusioniControl(form, 'my_SchedaPropostaLiqCoatta.my_ckAvvProtesti').value;
        const my_ckAvvAltro: string | boolean = getConclusioniControl(form, 'my_SchedaPropostaLiqCoatta.my_ckAvvAltro').value;

        const showError =
            isNilOrEmpty(my_descAzAvviateControl.value) &&
            (toBoolean(my_ckAvvIstanzaFall) || toBoolean(my_ckAvvDecrIngiunt) || toBoolean(my_ckAvvAzEsec) || toBoolean(my_ckAvvProtesti) || toBoolean(my_ckAvvAltro));
        const errors = my_descAzAvviateControl.errors ? my_descAzAvviateControl.errors : {};

        addRemoveError(showError, errors, 'my_descAzAvviate', {
            status: REQUIRED_STATUS,
        });

        my_descAzAvviateControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ckSituazPatrAggiorn: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaLiqCoatta.my_ckSituazPatrAggiorn', 'my_CkProvvedimendoDi', 5);
    },

    my_descSituazPatrAggiorn: (form: FormGroup) => {
        const conclusioniGroup = getGroup(form, formPaths.conclusioni);
        const my_descSituazPatrAggiornControl = getControl(conclusioniGroup, 'my_SchedaPropostaLiqCoatta.my_descSituazPatrAggiorn');
        const my_ckSituazPatrAggiorn: string = getControl(conclusioniGroup, 'my_SchedaPropostaLiqCoatta.my_ckSituazPatrAggiorn').value;
        const my_CkProvvedimendoDi: string = getControl(conclusioniGroup, 'my_CkProvvedimendoDi').value;
        const showError = isNilOrEmpty(my_descSituazPatrAggiornControl.value) && my_ckSituazPatrAggiorn === '0' && my_CkProvvedimendoDi === '5';
        const errors = my_descSituazPatrAggiornControl.errors ? my_descSituazPatrAggiornControl.errors : {};

        addRemoveError(showError, errors, 'my_descSituazPatrAggiorn', {
            status: REQUIRED_STATUS,
        });

        my_descSituazPatrAggiornControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ckOmessoStipContr: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaLiqCoatta.my_ckOmessoStipContr', 'my_CkProvvedimendoDi', 5);
    },

    my_descOmessoStipContr: (form: FormGroup) => {
        const my_descOmessoStipContrControl = getConclusioniControl(form, 'my_SchedaPropostaLiqCoatta.my_descOmessoStipContr');
        const my_CkProvvedimendoDi: string = getConclusioniControl(form, 'my_CkProvvedimendoDi').value;
        const my_ckOmessoStipContr: string = getConclusioniControl(form, 'my_SchedaPropostaLiqCoatta.my_ckOmessoStipContr').value;
        const showError = isNilOrEmpty(my_descOmessoStipContrControl.value) && my_ckOmessoStipContr === '1' && my_CkProvvedimendoDi === '5';
        const errors = my_descOmessoStipContrControl.errors ? my_descOmessoStipContrControl.errors : {};

        addRemoveError(showError, errors, 'my_descOmessoStipContr', {
            status: REQUIRED_STATUS,
        });

        my_descOmessoStipContrControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_sitPatrAggTotCrediti: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_sitPatrAggTotCrediti');
    },

    my_sitPatrAggImmMat: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_sitPatrAggImmMat');
    },

    my_sitPatrAggRiman: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_sitPatrAggRiman');
    },

    my_sitPatrAggPatrNetto: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_sitPatrAggPatrNetto');
    },

    my_sitPatrAggTotDeb: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_sitPatrAggTotDeb');
    },

    my_sitPatrAggTotPAss: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_sitPatrAggTotPAss');
    },

    my_sitPatrAggDebEntrEsSucc: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_sitPatrAggDebEntrEsSucc');
    },

    my_sitPatrAggAttCirc: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_sitPatrAggAttCirc');
    },

    my_sitPatrAggImmob: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_sitPatrAggImmob');
    },

    my_dtaSitPatrimAggiorn: (form: FormGroup) => {
        isEmptyForSituaz1AndProvv5(form, 'my_SchedaPropostaLiqCoatta.my_dtaSitPatrimAggiorn');
    },
};

const isEmptyForSituaz1AndProvv5 = (form: FormGroup, targetPath: string) => {
    const targetControl = getConclusioniControl(form, targetPath);
    const my_CkProvvedimendoDi: string = getConclusioniControl(form, 'my_CkProvvedimendoDi').value;
    const my_ckSituazPatrAggiorn: string = getConclusioniControl(form, 'my_SchedaPropostaLiqCoatta.my_ckSituazPatrAggiorn').value;
    const targetNameSplitted = targetPath?.split('.');
    const errorName = targetNameSplitted[targetNameSplitted.length - 1];
    const showError = isNilOrEmpty(targetControl.value) && my_ckSituazPatrAggiorn === '1' && my_CkProvvedimendoDi === '5';
    const errors = targetControl.errors ? targetControl.errors : {};

    addRemoveError(showError, errors, errorName, {
        status: REQUIRED_STATUS,
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};
